// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TakePhoto_wrapper__2h6I5","video":"TakePhoto_video__Hg5bk","photoButton":"TakePhoto_photoButton__1EDN0"};